import { render, staticRenderFns } from "./NoFind.vue?vue&type=template&id=268a6ff4&"
import script from "./NoFind.vue?vue&type=script&lang=js&"
export * from "./NoFind.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports